import React from 'react'
import { useTranslation } from '@structura/i18n'

export type InfoBannerVariant = 'info' | 'success' | 'warning' | 'danger'

interface InfoBannerProps {
  title: string
  lines: string[]
  variant?: InfoBannerVariant
  onClose?: () => void
}

const InfoBanner: React.FC<InfoBannerProps> = ({ title, lines, variant = 'info', onClose }) => {
  const { t } = useTranslation()
  const variantClass =
    variant === 'success'
      ? 'bg-success bg-opacity-10 border-success text-success'
      : variant === 'warning'
        ? 'bg-warning bg-opacity-10 border-warning text-warning'
        : variant === 'danger'
          ? 'bg-danger bg-opacity-10 border-danger text-danger'
          : 'bg-info bg-opacity-10 border-info text-info'

  return (
    <div
      className={`border rounded-3 p-3 mb-4 mt-2 ${variantClass}`}
      style={{
        maxWidth: '1400px',
        width: '100%',
        margin: '0 auto',
        boxShadow: '0 0.25rem 0.75rem rgba(0, 0, 0, 0.05)'
      }}
    >
      <div className="d-flex align-items-start">
        <div className="me-3">
          {/* Simple logo-inspired mark: hammer icon in a circle */}
          <div
            className="d-flex align-items-center justify-content-center rounded-circle"
            style={{
              width: '36px',
              height: '36px',
              background: 'linear-gradient(135deg, rgba(13,110,253,0.9), rgba(32,201,151,0.9))',
              color: 'white',
              boxShadow: '0 0.1rem 0.3rem rgba(0,0,0,0.15)'
            }}
          >
            <i className="bi bi-graph-up" />
          </div>
        </div>
        <div className="flex-grow-1">
          <div className="d-flex justify-content-between align-items-start mb-1">
            <h6 className="mb-0 fw-bold">{title}</h6>
            {onClose && (
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary ms-3"
                onClick={onClose}
              >
                <i className="bi bi-x-lg me-1" />
                {t('beam.common.close')}
              </button>
            )}
          </div>
          <div style={{ fontSize: '0.9rem', whiteSpace: 'pre-line' }}>
            {lines.map((line, index) => (
              <div key={index}>{line}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InfoBanner


